var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medical_Support",
    "data-name": "Medical Support",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#ebfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "medical-kit",
    d: "M19,33.875h2.125V36a2.125,2.125,0,0,0,4.25,0V33.875H27.5a2.125,2.125,0,0,0,0-4.25H25.375V27.5a2.125,2.125,0,0,0-4.25,0v2.125H19a2.125,2.125,0,0,0,0,4.25ZM38.125,10.5h-4.25V8.375A6.375,6.375,0,0,0,27.5,2H19a6.375,6.375,0,0,0-6.375,6.375V10.5H8.375A6.375,6.375,0,0,0,2,16.875v21.25A6.375,6.375,0,0,0,8.375,44.5h29.75A6.375,6.375,0,0,0,44.5,38.125V16.875A6.375,6.375,0,0,0,38.125,10.5ZM16.875,8.375A2.125,2.125,0,0,1,19,6.25h8.5a2.125,2.125,0,0,1,2.125,2.125V10.5H16.875ZM40.25,38.125a2.125,2.125,0,0,1-2.125,2.125H8.375A2.125,2.125,0,0,1,6.25,38.125V23.25h34ZM40.25,19h-34V16.875A2.125,2.125,0,0,1,8.375,14.75h29.75a2.125,2.125,0,0,1,2.125,2.125Z",
    transform: "translate(478.25 191)",
    fill: "#34b0eb",
    stroke: "#ebfdfd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalSupport);
export default __webpack_public_path__ + "static/media/MedicalSupport.805e41341004d43eb0b015ab5a56cec3.svg";
export { ForwardRef as ReactComponent };